// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".no-border-left{min-width:180px!important}@media only screen and (min-width:600px){.no-border-left{min-width:224px!important}}.no-border-left .vs__dropdown-toggle{border-top-left-radius:0!important;border-bottom-left-radius:0!important;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.15),0 1px 1px rgba(0,0,0,.075)}", ""]);
// Exports
module.exports = exports;
